<template>
  <v-card class="hide-overflow fill-height" color="white lighten-1" lighten>
    <v-card-title class="justify-center" :style="'background-color:' + corCab">
      <a :href="urlSite"><img style="max-height: 70px" class="img-responsive" :src="logotipo" :alt="nomeSite" :title="nomeSite" /></a>
      <v-progress-linear :active="carregando" class="ma-0" color="cyan accent-3" height="3" indeterminate></v-progress-linear>
    </v-card-title>
    <v-card-text>
      <v-data-iterator :items="planos" hide-default-footer :no-data-text="semPlanos" class="text-center">
        <template v-slot:default="props">
          <v-row class="justify-center">
            <v-col v-for="plano in planos" :key="plano._id" :item="plano" :value="plano._id" cols="12" md="6" xs="12">
              <v-card class="mx-auto text-center suita-block-home">
                <v-card-title class="justify-center">
                  <h3 style="color: #777">{{ plano.nome }}</h3>
                </v-card-title>

                <v-card-subtitle class="mt-2">
                  <v-divider></v-divider>

                  <div class="mt-4 ajustarImagem" v-html="plano.descricaoHtml"></div>

                  <v-divider class="mb-4"></v-divider>

                  <v-btn style="width: 100%" class="primary" large @click="assinar(plano.url)">
                    Assine &nbsp;&nbsp;
                    <span><i> agora!</i></span>
                  </v-btn>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <v-card-actions>
        <v-row class="justify-center text-center">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <span>{{ rodape }}</span>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card-text>
    <v-snackbar v-model="snackErro" color="error" :timeout="5000" centered>{{ mensagemErro }}</v-snackbar>
  </v-card>
</template>

<script>
import util from "../util";
import { api } from "@/services/api.js";
export default {
  data() {
    return {
      logotipo: "",
      urlSite: "",
      nomeSite: "",
      corCab: "#fff",
      planos: [],
      snackErro: false,
      mensagemErro: "",
      semPlanos: "",
      rodape: "",
      carregando: true
    };
  },
  methods: {
    async carregarPlanos() {
      try {
        const response = await api.get("/ass/paywall/planos?site=1");

        if (response.data.length) {
          this.planos = response.data;
          var urlApi = (window.location.host.includes("localhost") ? "http://localhost:3000" : "") + "/api/";
          this.logotipo = `${urlApi}arquivos/${this.$store.state.site.id}/logo.png`;
          this.urlSite = this.$store.state.site.enderecoSite;
          this.nomeSite = this.$store.state.site.nome;
          this.corCab = this.$store.state.site.corCab;
        }
      } catch {
        this.semPlanos = "Não há planos disponíveis para assinatura - entre em contato com o jornal";
      }
    },
    assinar(url) {
      if (!this.$store.state.login) {
        this.$router.push("/login?tab=" + (this.$store.state.site.assinante ? "1" : "0") + "&redirect=/plano/" + url);
      } else if (this.$store.state.usuario.idDependente) {
        if (this.$store.state.site.flip) {
          this.$router.push("/newflip");
        } else {
          this.$router.push("/alterar-senha");
        }
      } else {
        if (this.$store.state.usuario.cobranca && !this.$store.state.usuario.cobranca.statusCredito) {
          this.mensagemErro = "Operação não permitida - entre em contato com o jornal";
          this.snackErro = true;
          return;
        }
        this.$router.push("/plano/" + url);
      }
    }
  },
  async created() {
    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);

    if (!this.$store.state.site.paywall || this.$store.state.usuario.idDependente) {
      if (this.$store.state.site.flip) {
        this.$router.push("/newflip");
      } else {
        this.$router.push("/alterar-senha");
      }
    } else {
      var site = this.$store.state.site;
      this.rodape = `${site.razaoSocial} - CNPJ: ${util.formatIdentificacao(site.identificacao)} - ${site.logradouro}, ${site.numero}${
        site.complemento ? " - " + site.complemento : ""
      } - ${site.bairro} - ${site.municipio}/${site.uf} - CEP: ${site.cep.substring(0, 5)}-${site.cep.substring(5)} - Telefone: (${site.foneDDD}) ${site.foneNumero}`;

      document.title = this.$store.state.site.nome;
      await this.carregarPlanos();
      this.carregando = false;
    }
  }
};
</script>

<style>
.ajustarImagem img {
  max-width: 100%;
}
.suita-block-home:hover {
  box-shadow: 0 0.5rem 2rem #e1e1e1;
}
.suita-block-home:hover {
  box-shadow: 0 0.5rem 2.5rem #e6e6e6;
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
  opacity: 1;
}
.suita-block-home {
  display: block;
  color: #575757;
  font-weight: 400;
  transition: opacity 0.15s ease-out, box-shadow 0.15s ease-out, -webkit-transform 0.15s ease-out;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out, box-shadow 0.15s ease-out;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out, box-shadow 0.15s ease-out, -webkit-transform 0.15s ease-out;
}
</style>
